module.exports = __webpack_public_path__ + "static/media/Click.10d7445a.mp3";